module.exports = __webpack_public_path__ + "img/afghanistan.133f0a34.png";